import { jsPDF } from "jspdf";
import "jspdf-autotable";

const ExportPdf = (ImageUrl, currentData, Dt1, Dt2,radiationName,LoggedInUserInfo,logo,tableHeaders) => {
    const doc = new jsPDF({ orientation: 'landscape', format: [300, 700] });

    const pageWidth = doc.internal.pageSize.width;
    const textX = 10;   // Left margin
    const textY = 10;   // Top margin

    // ==== LEFT SIDE (Company Info) ====
    doc.setFontSize(15);
    doc.text(`Plant Name/User Name: ${LoggedInUserInfo?.username || ""}`, textX, textY + 10);

    doc.setFontSize(10);
    doc.text(`Plant Capacity: ${LoggedInUserInfo?.PLANT_CAPACITY || ""}`, textX, textY + 16);
    doc.text(`Plant Address: ${LoggedInUserInfo?.Address || ""}`, textX, textY + 22);

    // ==== CENTER (Main Logo) ====
    if (logo) {
        const imgWidth = 30;
        const imgHeight = 20;
        const xCenter = (pageWidth - imgWidth) / 2;
        doc.addImage(logo, "PNG", xCenter, 10, imgWidth, imgHeight);
    }

    // ==== RIGHT SIDE (Another Logo / ISO mark) ====
    if (ImageUrl) {
        const rightImgWidth = 100;
        const rightImgHeight = 25;
        const xRight = pageWidth - rightImgWidth - 10;
        doc.addImage(ImageUrl, "PNG", xRight, 12, rightImgWidth, rightImgHeight);
    }

    // ==== TITLE (Below Header) ====
    const title = `${radiationName} From ${Dt1} To ${Dt2}`;
    doc.setFontSize(12);
    doc.text(title, pageWidth / 2, 40, { align: "center" });

    // ==== TABLE START ====
    let startY = 50;
    doc.autoTable({
        head: [tableHeaders],
        body: currentData.map((item) =>
            tableHeaders.map((key) => item[key] ?? "")
        ),
        startY: startY,
        theme: "grid",
    });

    // ==== SAVE FILE ====
    doc.save(`${radiationName} From ${Dt1} To ${Dt2}.pdf`);

};

export default ExportPdf;